import { User } from 'lucide-react';
import { Outlet, useLocation } from 'react-router';

import { Page, PageBody } from './page';
import { PageSidebar } from './page-sidebar';

import { useTenant } from '@/context';

const navItems = [{ title: 'General', icon: User, path: '' }];

export function ProfileLayout() {
    const location = useLocation();
    const { tenantId } = useTenant();

    const basePath = '/profile';
    const casesPath = tenantId ? `/tenants/${tenantId}` : '/';

    const isActive = (path: string) => {
        const fullPath = path ? `${basePath}/${path}` : basePath;
        return location.pathname === fullPath;
    };

    return (
        <Page>
            <PageBody scroll="y">
                <div className="flex flex-col md:flex-row md:gap-6">
                    <PageSidebar
                        title="User Settings"
                        navItems={navItems}
                        basePath={basePath}
                        backLink={{ label: 'Back to Cases', href: casesPath }}
                        isActive={isActive}
                    />
                    <div className="flex-1 min-w-0">
                        <Outlet />
                    </div>
                </div>
            </PageBody>
        </Page>
    );
}
